import Loadable from '../../components/loadable';

const Subscriptions = Loadable({
  loader: () => import('../../pages/subscriptions/subscriptions'),
  type: 'block',
});

angular.module('gym').value('Subscriptions', Subscriptions);
